/* セレクトコントロール */
import React, { memo } from 'react';
import Messages from '../Messages';
var InputSelect = function (_a) {
    var id = _a.id, title = _a.title, class_name = _a.class_name, title_class_name = _a.title_class_name, name = _a.name, value = _a.value, handleChange = _a.handleChange, options = _a.options, help_message = _a.help_message, valid_message = _a.valid_message, _b = _a.disabled, disabled = _b === void 0 ? false : _b, t = _a.t;
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: title_class_name ? title_class_name : "detail-criteria-head" }, title),
        React.createElement("div", { className: "detail-form-input" },
            React.createElement("select", { id: id, name: name, className: class_name, value: value, onChange: handleChange, disabled: disabled },
                React.createElement("option", null), options === null || options === void 0 ? void 0 :
                options.map(function (option, index) {
                    return (React.createElement("option", { key: index, value: option.key }, t(option.value)));
                })),
            React.createElement(Messages, { help_msg: help_message, valid_msg: valid_message }))));
};
export default memo(InputSelect);
